import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  selectedDate: new Date().toISOString(),
};

export const salarySlice = createSlice({
  name: 'salaryState',
  initialState,
  reducers: {
    setSelectedDate: (state, action: PayloadAction<string>) => {
      state.selectedDate = action.payload;
    },
  },
});

export const { setSelectedDate } = salarySlice.actions;
export default salarySlice.reducer;
